import { render, staticRenderFns } from "./account.vue?vue&type=template&id=1bd419ac&scoped=true&"
import script from "./account.vue?vue&type=script&lang=ts&"
export * from "./account.vue?vue&type=script&lang=ts&"
import style0 from "./account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./account.vue?vue&type=style&index=1&id=1bd419ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd419ac",
  null
  
)

export default component.exports